// @flow

import notFoundRoute from '../routes/not-found';

export type Route = {
  path: string,
  component: any,
  privileges?: Array<string> | typeof undefined,
  disallowedIntegrationTypes?: Array<string> | typeof undefined,
  fetchData?: Array<Function> | typeof undefined,
  routes?: Array<Route> | typeof undefined,
  exact?: boolean | typeof undefined
};

export type RouteOptions = {
  privileges?: Array<string> | typeof undefined,
  disallowedIntegrationTypes?: Array<string> | typeof undefined,
  fetchData?: Array<Function> | typeof undefined,
  routes?: Array<Route> | typeof undefined,
  exact?: boolean | typeof undefined,
  disabledNotFound?: boolean
};

/**
 * Create route object
 * @param path
 * @param component
 * @param privilege
 * @param disallowedIntegrationTypes
 * @param fetchData
 * @param routes
 * @param exact
 * @param disabledNotFound
 * @returns {{path: *, component: *, privileges: array, fetchData: *, routes: *, exact: boolean}}
 */
export default (
  path: string,
  component: any,
  {
    privileges,
    disallowedIntegrationTypes,
    fetchData,
    routes,
    exact,
    disabledNotFound
  }: RouteOptions = {
    privileges: [],
    disallowedIntegrationTypes: [],
    fetchData: void 0,
    routes: void 0,
    exact: false,
    disabledNotFound: false
  }
): Route => {
  if (routes && !disabledNotFound) {
    routes.push(notFoundRoute);
  }
  return {path, component, privileges, disallowedIntegrationTypes, fetchData, routes, exact};
};
